import type { CourseModel, ParticipantExtendedModel } from '../data/types';

export const getActiveParticipantsCount = (
  participants?: ParticipantExtendedModel[],
  course?: CourseModel
): number => {
  if (participants && participants.length > 0) {
    return participants.filter(p => p.desktop?.isRunning).length;
  }

  if (course && typeof course.activeParticipantCount === 'number') {
    return course.activeParticipantCount;
  }

  return 0;
};

export const getJoinedParticipantsCount = (
  participants?: ParticipantExtendedModel[],
  course?: CourseModel
): number => {
  if (participants && participants.length > 0) {
    return participants.length;
  }

  if (course && typeof course.participantCount === 'number') {
    return course.participantCount;
  }

  return 0;
};

export const getExpectedParticipantsCount = (course: CourseModel): number =>
  course.expectedParticipants ?? course.maxParticipants ?? 0;

export const isCourseInSession = (course: CourseModel): boolean =>
  course.flags?.isInSession ?? false;
